/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNavRefineMenuFilters_viewer = {
    readonly isMatchedSetsEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterDeliveryOptions_viewer">;
    readonly " $refType": "BuyMobileNavRefineMenuFilters_viewer";
};
export type BuyMobileNavRefineMenuFilters_viewer$data = BuyMobileNavRefineMenuFilters_viewer;
export type BuyMobileNavRefineMenuFilters_viewer$key = {
    readonly " $data"?: BuyMobileNavRefineMenuFilters_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNavRefineMenuFilters_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNavRefineMenuFilters_viewer",
  "selections": [
    {
      "alias": "isMatchedSetsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableMatchedSetsFacet"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '0d42ef22d961f466a9483e0a9c853253';
export default node;
